import props from "./../../../src-utils/propDefiner";

export default {
  ...props("options", { type: Array }, "pm-select"),
  ...props("placeholder", { type: String }, "pm-select"),
  ...props("name", { type: String }, "pm-select"),
};
